import { render, staticRenderFns } from "./MenuDesktop.vue?vue&type=template&id=74719ef2&scoped=true&"
import script from "./MenuDesktop.vue?vue&type=script&lang=js&"
export * from "./MenuDesktop.vue?vue&type=script&lang=js&"
import style0 from "./MenuDesktop.vue?vue&type=style&index=0&id=74719ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74719ef2",
  null
  
)

export default component.exports